import React from 'react'

const stars = () => {
    return (
        <>
     <svg id="star-1" width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.7285 0.505249L14.6559 8.33238L23.2285 11.0052L14.6559 13.6781L11.7285 21.5052L8.80109 13.6781L0.228516 11.0052L8.80109 8.33238L11.7285 0.505249Z" fill="#2793BC"/>
    </svg>

    <svg id="star-2" width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.7285 0.505249L14.6559 8.33238L23.2285 11.0052L14.6559 13.6781L11.7285 21.5052L8.80109 13.6781L0.228516 11.0052L8.80109 8.33238L11.7285 0.505249Z" fill="#2793BC"/>
    </svg>

    <svg id="star-3" width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.7285 0.505249L14.6559 8.33238L23.2285 11.0052L14.6559 13.6781L11.7285 21.5052L8.80109 13.6781L0.228516 11.0052L8.80109 8.33238L11.7285 0.505249Z" fill="#2793BC"/>
    </svg>
                
        </>
    )
}

export default stars
